'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './build.routes';

export class BuildComponent {
  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getBuilds();
  }

  getBuilds() {
    this.page = this.$stateParams.page || 0;
    var params = {
      page: this.page
    };
    this.$http.get('/api/builds', {params: params}).then(response => {
      this.builds = response.data;
    });
  }

  previousPage() {
    if (this.page == 0) {
      return;
    }
    this.page--;
    this.$state.go('build', {page: this.page});
  }

  nextPage() {
    this.page++;
    this.$state.go('build', {page: this.page});
  }

  delete(id) {
  if (confirm("确定？")) {
      this.$http.delete(`/api/builds/${id}`).then(response => {
        this.getBuilds();
      });
    }
  }

}

export default angular.module('logServerApp.build', [uiRouter])
  .config(routes)
  .component('build', {
    template: require('./build.html'),
    controller: BuildComponent,
    controllerAs: 'buildCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/build/build.component.js